export const cartConstants = {
    ADD: 'add',
    ADD_DETAILS: 'add-details',
    EDIT_DETAIL: 'edit-details',
    EDIT_DETAIL_VENDOR_IDENTIFIER: 'edit-detail-vendor-identifier',
    REMOVE_DETAIL: 'remove-detail',
    ADD_DETAIL: 'add-detail',
    REMOVE: 'remove',
    CLEAR: 'clear',
    GET: 'get',
    EDIT_PROJECT_FEATURE: 'edit-project-feature',
};
